/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

const GroupLoanCollectionReciept = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // location.state से सेफली डेटा निकालना
  const stateData = location.state || {};
  const emi = stateData.r || stateData.emi || {};
  const nextemi = stateData.nextemi || stateData.nextEmi || null;
  const unusedAmount = stateData.unusedAmount || 0;

  const receiptRef = useRef(null);
  const thermalReceiptRef = useRef(null);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const [company, setCompany] = useState(null);

  // Fetch profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch company info
  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
      );
      const data = await res.json();
      if (res.ok && data) {
        if (data.logo) {
          data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
        }
        if (data.qrCodeImage) {
          data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
        }
        setCompany(data);
      }
    } catch (err) {
      console.error("Error fetching company:", err);
    }
  };

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchCompany();
    }
  }, [profile?.superAdminId]);

  const handlePrint = async () => {
    if (!receiptRef.current) return;
    const pdf = new jsPDF("p", "mm", "a4");
    const canvas = await html2canvas(receiptRef.current, {
      scale: 1.5,
      useCORS: true,
      backgroundColor: "#fff",
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.9);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);
    const blobUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      window.addEventListener(
        "focus",
        () => {
          setTimeout(() => {
            if (document.body.contains(iframe))
              document.body.removeChild(iframe);
          }, 500);
        },
        { once: true },
      );
    };
  };

  const handlePrintThermalSlip = async () => {
    if (!thermalReceiptRef.current) return;
    try {
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <style>
              @page { size: 58mm auto; margin: 0; }
              body { margin: 0; padding: 0; display: flex; flex-direction: column; align-items: center; }
              img { width: 58mm; max-width: 58mm; margin: 0 auto; display: block; }
            </style>
          </head>
          <body></body>
        </html>
      `);
      doc.close();

      const canvas = await html2canvas(thermalReceiptRef.current, {
        scale: 3,
        backgroundColor: "#fff",
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const img = doc.createElement("img");
      img.src = imgData;

      await new Promise((res) => (img.onload = res));
      doc.body.appendChild(img);

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 300);
    } catch (err) {
      console.error("Thermal printing failed", err);
      alert("Thermal print failed");
    }
  };

  if (!emi) {
    return <div className="p-10 text-center">Receipt Data Not Found</div>;
  }

  const isPartial = emi?.status?.toLowerCase()?.includes("partial");
 const advanceAmount = Number(unusedAmount || 0);

const isAdvance = advanceAmount > 0;

  const partialPaymentsHistory = [];
  let calculatedTotalPaid = 0;

  for (let i = 1; i <= 5; i++) {
    const amount = emi[`payment${i}`];
    const date = emi[`payment${i}Date`] || emi?.paidDate || emi?.lastPaidDate;
    const mode = emi[`payment${i}Mode`];
    if (amount !== null && amount !== undefined && amount > 0) {
      partialPaymentsHistory.push({ index: i, amount, date, mode });
      calculatedTotalPaid += Number(amount);
    }
  }

  const totalPaidTillDate =
    calculatedTotalPaid > 0
      ? calculatedTotalPaid
      : Number(emi?.paidAmount || 0);

  const receiptDate =
    emi?.lastPaidDate ||
    emi?.paidDate ||
    emi?.paymentDate ||
    emi?.updatedAt ||
    new Date().toISOString();

  const penaltyAmount = Number(
    emi?.penaltyAmount === 0 ? emi?.penalty || 0 : emi?.penaltyAmount || 0,
  );
  const totalPayable = (emi?.emiAmount || 0) + penaltyAmount;

  return (
    <div className="receipt-viewer-container">
      {/* Action Buttons */}
      <div className="receipt-actions receipt-no-print">
        <button onClick={() => navigate(-1)} className="receipt-back-btn">
          Back
        </button>
        <button onClick={handlePrint} className="btn-print-receipt">
          Print Receipt
        </button>
        <button
          onClick={handlePrintThermalSlip}
          className="btn-thermal-print-receipt"
        >
          Thermal Print Receipt
        </button>
      </div>

      {/* A4 Printable Receipt Design */}
      <div
        id="receipt-0"
        style={{ pageBreakAfter: "always" }}
        className="receipt-paper"
        ref={receiptRef}
      >
        <div className="receipt-header-section">
          <div className="receipt-header-company-section">
            <div className="receipt-company-details">
              {company?.logoUrl && (
                <img
                  src={company.logoUrl}
                  alt="logo"
                  className="receipt-logo"
                />
              )}
              <div className="receipt-header-company-info">
                <h1>{company?.name || "TechVision Finance"}</h1>
                <p className="address">
                  <b>Address: </b>
                  {company?.address || "N/A"}
                </p>
                <p className="contact">
                  <b>Phone:</b> {company?.contact || "N/A"} | <b>Email:</b>{" "}
                  {company?.email || "N/A"}
                </p>
                <p className="cin">
                  <b>CIN:</b> {company?.cin || "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="receipt-title-box">
            <h2>GROUP COLLECTION RECEIPT</h2>
            <span className={`status-badge-top ${emi?.status?.toLowerCase()}`}>
              {emi?.status?.toUpperCase()}
            </span>
            <p>
              Receipt No: #{emi?.id || "N/A"} | Date:{" "}
              {new Date(receiptDate).toLocaleDateString("en-GB")}
            </p>
          </div>
        </div>

        {/* Customer & Group Loan Info */}
        <div className="receipt-section">
          <h3 className="receipt-section-title">GROUP ACCOUNT DETAILS</h3>
          <div className="receipt-details-wrapper text-dark-design">
            <div className="receipt-grid-item">
              <span>Group Loan Account Id:</span>{" "}
              <strong>{emi?.grouploanAccountId || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Installment No:</span>{" "}
              <strong>{emi?.installmentNo || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Due Date:</span>{" "}
              <strong>
                {emi?.dueDate
                  ? new Date(emi.dueDate).toLocaleDateString("en-IN")
                  : "N/A"}
              </strong>
            </div>
          </div>
        </div>

        {/* Financial Summary */}
        <div className="receipt-section">
          <h3 className="receipt-section-title">FINANCIAL SUMMARY</h3>
          <div className="receipt-details-wrapper payment-summary-box">
            <div className="receipt-grid-item">
              <span>Standard EMI Amount:</span>{" "}
              <strong>₹{(emi?.emiAmount || 0).toLocaleString("en-IN")}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Penalty Charges:</span>{" "}
              <strong className="text-danger">
                ₹{penaltyAmount.toLocaleString("en-IN")}
              </strong>
            </div>
            <div className="receipt-grid-item total-payable-row">
              <span>Total Payable (EMI + Penalty):</span>{" "}
              <strong>₹{totalPayable.toLocaleString("en-IN")}</strong>
            </div>

            {isPartial && (
              <>
                <div className="receipt-grid-item total-paid-highlight">
                  <span>Total Paid Till Date:</span>{" "}
                  <strong className="text-success">
                    ₹{totalPaidTillDate.toLocaleString("en-IN")}
                  </strong>
                </div>
                <div className="receipt-grid-item balance-highlight">
                  <span>Remaining EMI Balance:</span>{" "}
                  <strong className="text-warning">
                    ₹{(emi?.emiBalance || 0).toLocaleString("en-IN")}
                  </strong>
                </div>
              </>
            )}

            {isAdvance && (
              <div className="receipt-grid-item advance-highlight">
                <span>Advance Paid Amount:</span>{" "}
                <strong>₹{Number(unusedAmount).toLocaleString("en-IN")}</strong>
              </div>
            )}

            {emi?.loanType !== "FIXED" && (
              <div className="receipt-grid-item">
                <span>Outstanding Balance:</span>{" "}
                <strong>
                  ₹{(emi?.outstanding || 0).toLocaleString("en-IN")}
                </strong>
              </div>
            )}

            {nextemi?.dueDate && (
              <div className="receipt-grid-item due-date-special">
                <span>Next Due Date:</span>{" "}
                <strong className="text-primary">
                  {new Date(nextemi.dueDate).toLocaleDateString("en-IN")}
                </strong>
              </div>
            )}
          </div>
        </div>

        {/* Dynamic Transaction Breakdown History */}
        {partialPaymentsHistory.length > 0 && (
          <div className="receipt-section">
            <h3 className="receipt-section-title">
              PAYMENT BREAKDOWN (TRANSACTION HISTORY)
            </h3>
            <table className="receipt-breakdown-table">
              <thead>
                <tr>
                  <th>Trx No.</th>
                  <th>Payment Date</th>
                  <th>Payment Mode</th>
                  <th style={{ textAlign: "right" }}>Amount Paid</th>
                </tr>
              </thead>
              <tbody>
                {partialPaymentsHistory.map((pay) => (
                  <tr key={pay.index}>
                    <td>#{pay.index}</td>
                    <td>
                      {pay.date
                        ? new Date(pay.date).toLocaleDateString("en-IN")
                        : "--"}
                    </td>
                    <td>
                      <span className="mode-tag">
                        {pay.mode || emi?.payment1Mode || "Cash"}
                      </span>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <strong>₹{pay.amount.toLocaleString("en-IN")}</strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="receipt-footer-signs" style={{ marginTop: "40px" }}>
          <div className="receipt-sign-box">
            <div className="receipt-sign-line"></div>
            <p>Authorized Signatory</p>
          </div>
          <div className="receipt-sign-box">
            <div className="receipt-sign-line"></div>
            <p>Customer Signature</p>
          </div>
        </div>

        <p className="receipt-system-gen-text">
          This is a system-generated slip and does not require a physical
          signature.
          <br />
          For any discrepancies, please contact us during business hours.
        </p>
      </div>

      {/* Thermal Print Design */}
      <div id="thermal-0" className="thermal-slip-wrapper">
        <div ref={thermalReceiptRef} className="thermal-slip">
          <div className="thermal-company">
            <div className="thermal-company-name">
              {company ? company.name : "--"}
            </div>
            <div className="thermal-company-text">
              <b>Address:</b> {company ? company.address : "--"}
            </div>
            <div className="thermal-company-text">
              <b>Phone:</b> {company ? company.contact : "--"}
            </div>
          </div>

          <div className="thermal-divider"></div>
          <div className="thermal-title">EMI COLLECTION SLIP</div>
          <div className="thermal-row">
            <b>Status:</b> {emi?.status?.toUpperCase()}
          </div>
          <div className="thermal-divider"></div>

          <div className="thermal-row">
            <b>Group Acc Id:</b> {emi?.grouploanAccountId || "--"}
          </div>
          <div className="thermal-row">
            <b>Inst No:</b> {emi?.installmentNo || "--"}
          </div>

          <div className="thermal-divider"></div>
          <div className="thermal-row">
            <b>EMI Amt:</b> ₹{emi?.emiAmount || "0"}
          </div>
          <div className="thermal-row">
            <b>Penalty:</b> ₹{penaltyAmount || "0"}
          </div>
          

          {isPartial && (
            <>
            <div className="thermal-row font-large">
            <b>Total Paid:</b> ₹{totalPaidTillDate}
          </div>
            <div className="thermal-row text-danger">
              <b>EMI Balance:</b> ₹{emi?.emiBalance || "0"}
            </div>
            </>
          )}
          {isAdvance && (
            <div className="thermal-row">
              <b>Adv Paid:</b> ₹{unusedAmount}
            </div>
          )}

          {/* Thermal Breakdown History */}
          {partialPaymentsHistory.length > 0 && (
            <>
              <div className="thermal-divider"></div>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                PAYMENT HISTORY
              </div>
              {partialPaymentsHistory.map((p) => (
                <div
                  className="thermal-row"
                  style={{ fontSize: "10px" }}
                  key={p.index}
                >
                  <span>
                    Txn#{p.index} ({p.mode || "Cash"}):
                  </span>
                  <strong>₹{p.amount}</strong>
                </div>
              ))}
            </>
          )}

          <div className="thermal-divider"></div>
          {emi?.loanType !== "FIXED" && (
            <div className="thermal-row">
              <b>Outstanding:</b> ₹{emi?.outstanding || "0"}
            </div>
          )}
          {nextemi?.dueDate && (
            <div className="thermal-row">
              <b>Next Due:</b>{" "}
              {new Date(nextemi.dueDate).toLocaleDateString("en-GB")}
            </div>
          )}
          <div className="thermal-row">
            <b>Payment Date:</b>{" "}
            {new Date(receiptDate).toLocaleDateString("en-GB")}
          </div>

          <div className="thermal-divider"></div>
          <div className="thermal-footer">
            <div>Thank you for your payment!</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupLoanCollectionReciept;
